import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Category from './Category'
import Photo from './Photo'
import Products from './Products'
import Orders from './Orders'
import '../styles/Admin.css'

const TABS = [
  { key: 'products',    label: 'პროდუქტები' },
  { key: 'categories',  label: 'კატეგორიები' },
  { key: 'photos',      label: 'ფოტო' },
  { key: 'orders',      label: 'შეკვეთები' },
]

function Admin() {
  const [activeTab, setActiveTab] = useState('products')
  const [menuOpen, setMenuOpen] = useState(false)
  const navigate = useNavigate()

  const handleLogout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('isAuthenticated')
    navigate('/')
  }

  const handleTabClick = (key) => {
    setActiveTab(key)
    setMenuOpen(false)
  }

  return (
    <div className="adm-layout">

      {/* Mobile topbar */}
      <div className="adm-mobile-topbar">
        <button className="adm-menu-toggle" onClick={() => setMenuOpen(true)}>☰</button>
        <span className="adm-mobile-brand">YourHood</span>
      </div>

      {/* Backdrop */}
      {menuOpen && (
        <div className="adm-backdrop" onClick={() => setMenuOpen(false)} />
      )}

      {/* Sidebar */}
      <aside className={`adm-sidebar ${menuOpen ? 'open' : ''}`}>
        <div className="adm-sidebar-header">
          <div className="adm-brand">YourHood</div>
          <button className="adm-close-btn" onClick={() => setMenuOpen(false)}>✕</button>
        </div>
        <nav className="adm-nav">
          {TABS.map(tab => (
            <button
              key={tab.key}
              className={`adm-nav-item ${activeTab === tab.key ? 'active' : ''}`}
              onClick={() => handleTabClick(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </nav>
        <button className="adm-logout" onClick={handleLogout}>
          გასვლა
        </button>
      </aside>

      {/* Main */}
      <main className="adm-main">
        <div className="adm-topbar">
          <h1 className="adm-topbar-title">
            {TABS.find(t => t.key === activeTab)?.label}
          </h1>
        </div>
        <div className="adm-content">
          {activeTab === 'products'   && <Products />}
          {activeTab === 'categories' && <Category />}
          {activeTab === 'photos'     && <Photo />}
          {activeTab === 'orders'     && <Orders />}
        </div>
      </main>

    </div>
  )
}

export default Admin